import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreditInfo, StoreProfile } from '../../core/models';

export const ProfileActions = createActionGroup({
  source: 'Profile',
  events: {
    'Load Profile': emptyProps(),
    'Load Profile Success': props<{ profile: StoreProfile }>(),
    'Load Profile Failure': props<{ error: string }>(),

    // Live credit line for the signed-in store.
    'Load Credit Info': emptyProps(),
    'Load Credit Info Success': props<{ credit: CreditInfo }>(),
    'Load Credit Info Failure': props<{ error: string }>(),
  },
});
